import $ from 'gridstrap/lib/gs-zepto';

export class GSFaqList {

	//
	// Properties
	//

	private root;
	private items;

	//
	// Methods
	//

	toggleItem(evt) {
		const question = $(evt.currentTarget);
		const item = question.closest('.gs-FaqList-item');
		item.toggleClass('gs-FaqList-item--open');
	}

	preventDoubleClick() {
		document['selection']?.empty?.()
		window.getSelection()?.removeAllRanges?.();
	}

	//
	// Initialiation
	//

	constructor(root) {
		this.root = $(root);
		this.items = this.root.find('.gs-FaqList-item');

		this.items
			.find('.gs-FaqList-itemHeader')
			.on('click', (evt) => this.toggleItem(evt))
			.on('dblclick', () => this.preventDoubleClick());
	}

}
